import axios from '../javascript/custom-axios'
const RESOURCE_NAME = 'tags'

export default {
  getTags() {
    return axios.get(`${RESOURCE_NAME}`)
  },
  createTags(body){
    return axios.post(`${RESOURCE_NAME}`,body)
 
  }
}